import axios from 'axios'
const URL = process.env.REACT_APP_DOBBY_URL

export const attachAssetsAction = (data, customer_id, asset_id) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'put',
      url: `${URL}/asset/attach?customer_id=${customer_id}&asset_id=${asset_id}`,
      data: data,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const deleteAssetAction = (data) => async (dispatch) => {
  console.log('delete asset', data)
  try {
    const res = await axios({
      method: 'delete',
      url: `${URL}/assets`,
      data: data,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

// ==================================

export async function getPresignedPostUrl(data) {
  // console.log('data Action', data.files[0])
  try {
    const signedPostUrl = await axios({
      method: 'post',
      url: `${URL}/asset/upload`,
      data: data,
    })
    return signedPostUrl.data
  } catch (error) {
    console.log('Error')
    // if(error.response.status === 500){

    // }
    return error.data
  }
}

export async function updateJobStatus(data, jobId, customerId) {
  try {
    const status = await axios({
      method: 'put',
      url: `${URL}/asset/upload?customer_id=${customerId}&job_id=${jobId}`,
      data: data,
    })
    // console.log('jobUpdate', status)
    return status.data
  } catch (error) {
    console.log('Error')
    return error.data
  }
}
export const getArtistAction = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/artist`,
    })
    // console.log('jobUpdate', status)
    return res.data
  } catch (error) {
    console.log('Error')
    return error.data
  }
}
export const getVenuesAction = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/venue`,
    })
    // console.log('jobUpdate', status)
    return res.data
  } catch (error) {
    console.log('Error')
    return error.data
  }
}

export const getParentContentAction = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/content/parent-content`,
    })
    return res.data
  } catch (error) {
    console.log('Error')
    return error.data
  }
}
